// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleListEmptyState_container__vKsXP","header":"VehicleListEmptyState_header__vVOxz","description":"VehicleListEmptyState_description__esF4q"};